import { Base } from "ui/Scripts/source/framework/base";
import { ListItems } from "ui/Scripts/source/framework/listItems";
import { ITaskTypeListItem, TaskTypeListItem } from "./taskTypeListItem";

export interface ITaskTypeListItems extends ListItems<ITaskTypeListItem> {
}

export class TaskTypeListItems extends ListItems<TaskTypeListItem> implements ITaskTypeListItems {
    constructor();
    constructor(obj: ITaskTypeListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, TaskTypeListItem);
    }
}